/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable-next-line react/prop-types */
/*
Author: Rendra Pramulia
*/

import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity, ActivityIndicator } from 'react-native';
import { useDispatch } from 'react-redux';
import Toast from 'react-native-toast-message';

import FormLabel from '@components/form/common/FormLabel';
import Image from '@components/global/Image';

import { uploadS3, chooseImagePicker } from '@global/helpers';
import Colors from '@global/colors';
import { showPopup } from '@/store/modal';
import PropTypes from 'prop-types';

const propTypes = {
  testID: PropTypes.string,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  widthPlaceholder: PropTypes.number,
  heightPlaceholder: PropTypes.number,
  placeholderImage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  images: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  notRenderLabel: PropTypes.bool,
};

const defaultProps = {
  testID: 'upload-image',
  label: '',
  isRequired: false,
  width: 70,
  height: 70,
  widthPlaceholder: 39,
  heightPlaceholder: 36,
  placeholderImage: '',
  images: '',
  style: {},
  notRenderLabel: false,
};

const FileImage = (props) => {
  const {
    testID = 'upload-image',
    label = '',
    isRequired = false,
    width = 70,
    height = 70,
    widthPlaceholder = 39,
    heightPlaceholder = 36,
    placeholderImage = '',
    images = '',
    style = {},
  } = props;

  const dispatch = useDispatch();
  const [image, setImage] = useState('');
  const [loading, setLoading] = useState(false);

  const chooseFile = async () => {
    const image = await chooseImagePicker();
    if (image && image.uri) {
      dispatch(showPopup({ name: 'isLoading', value: true }));
      try {
        setLoading(true);
        const url = await uploadS3({ file: image, isImage: true });
        dispatch(showPopup({ name: 'isLoading', value: false }));
        if (url) {
          // checkImage(url);
          setLoading(false);
          return url;
        } else {
          setLoading(false);
          Toast.show({
            text1: 'Failed to upload file. Please try again.',
            type: 'error',
          });
        }
      } catch (error) {
        setLoading(false);
        dispatch(showPopup({ name: 'isLoading', value: false }));
      }
    }
    return false;
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setImage(images);
    }
    return () => {
      mounted = false;
    };
  }, []);

  const Placeholder = ({ testID }) => {
    if (placeholderImage) {
      return (
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <Image
            testID={`${testID}-placeholder`}
            style={{ width: widthPlaceholder, height: heightPlaceholder }}
            width={widthPlaceholder}
            height={heightPlaceholder}
            source={placeholderImage}
          />
        </View>
      );
    }
  };

  return (
    <View>
      {!props?.notRenderLabel && (
        <FormLabel label={label} isRequired={isRequired} />
      )}
      <TouchableOpacity
        testID={testID}
        style={{
          width: width,
          height: height,
          backgroundColor: Colors.grey12,
          justifyContent: 'center',
          overflow: 'hidden',
          borderRadius: props?.notRenderLabel ? 8 : 4,
          ...style,
        }}
        onPress={async () => {
          const uploadImage = await chooseFile();
          if (uploadImage) {
            // eslint-disable-next-line react/prop-types
            props.onChange(uploadImage);
          }
        }}>
        {image ? (
          loading ? (
            <ActivityIndicator size="small" color={Colors.blue0} />
          ) : (
            <Image
              style={{ width: width, height: height }}
              width={width}
              height={height}
              source={image}
            />
          )
        ) : (
          <Placeholder testID={testID} />
        )}
      </TouchableOpacity>
    </View>
  );
};

FileImage.propTypes = propTypes;
FileImage.defaultProps = defaultProps;

export default React.memo(FileImage, (prev, next) => prev == next);
